(function () {
  'use strict';
  function syncHeroHeaderSpace() {
    var header = document.querySelector('.agp-header-overlay .header-container');
    document.documentElement.style.setProperty('--agp-hero-header-space', (header ? Math.ceil(header.getBoundingClientRect().height) : 0) + 'px');
  }
  var heroHeaderObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(syncHeroHeaderSpace) : null;
  function observeHeroHeader() {
    if (heroHeaderObserver) {
      heroHeaderObserver.disconnect();
      var header = document.querySelector('.agp-header-overlay .header-container');
      if (header) heroHeaderObserver.observe(header);
    }
    syncHeroHeaderSpace();
  }
  observeHeroHeader();
  window.addEventListener('resize', syncHeroHeaderSpace, { passive: true });
  // Native details elements remain usable without JavaScript.
  document.addEventListener('toggle', function (event) {
    var panel = event.target;
    if (!panel.matches || !panel.matches('.agp-vehicle[open]')) return;
    document.querySelectorAll('.agp-vehicle[open]').forEach(function (other) {
      if (other !== panel) other.open = false;
    });
  }, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest('.agp-vehicle')) return;
    document.querySelectorAll('.agp-vehicle[open]').forEach(function (panel) { panel.open = false; });
    var link = event.target.closest('#NavDrawer a');
    if (link && link.hash && link.pathname === window.location.pathname) {
      var close = document.querySelector('#NavDrawer .js-drawer-close');
      if (close) close.click();
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.agp-vehicle[open]').forEach(function (panel) {
      panel.open = false;
      panel.querySelector('summary').focus();
    });
  });
  function setupProductGuides(container) {
    container.querySelectorAll('[data-agp-product-guide]').forEach(function (guide) {
      if (guide.dataset.agpReady) return;
      var id = guide.dataset.productSection;
      var source = document.getElementById('ProductJson-' + id);
      var form = document.getElementById('AddToCartForm--' + id);
      if (!source || !form) return;
      var product;
      try { product = JSON.parse(source.textContent); } catch (_) { return; }
      guide.dataset.agpReady = 'true';
      function sync() {
        var selected = form.querySelector('[name="id"]');
        var options = [];
        form.querySelectorAll('[data-index]').forEach(function (input) {
          if (input.type !== 'radio' || input.checked) options[Number(input.dataset.index.replace('option','')) - 1] = input.value;
        });
        var variant = options.length ? product.variants.find(function (item) {
          return options.every(function (value, index) { return item.options[index] === value; });
        }) : product.variants.find(function (item) { return String(item.id) === (selected && selected.value); });
        if (!variant && !options.length) variant = product.variants[0];
        var sku = variant && variant.sku || '';
        var skuRow = guide.querySelector('[data-agp-sku-row]');
        if (skuRow) skuRow.hidden = !sku;
        var skuCell = guide.querySelector('[data-agp-sku]');
        if (skuCell) skuCell.textContent = sku;
        guide.querySelectorAll('[data-agp-option]').forEach(function (cell) {
          var index = Number(cell.dataset.agpOption);
          cell.textContent = variant ? variant.options[index] : options[index] || 'Unavailable';
        });
      }
      form.addEventListener('change', function () { window.setTimeout(sync, 0); });
      sync();
    });
  }
  setupProductGuides(document);
  document.addEventListener('shopify:section:load', function (event) { setupProductGuides(event.target); observeHeroHeader(); });
}());
